// extracted by mini-css-extract-plugin
module.exports = {"title":"_2q8aX","mobile":"_3JPrz"};